import { shouldDebugWithKey } from "@/lib/utils";
import { Events, SegmentEventData } from "./events";

const SEGMENT_DEBUG_EVENT_KEY = "segmentDebug";

export const sendEvent = (event: Events, data?: SegmentEventData) => {
  if (shouldDebugWithKey(SEGMENT_DEBUG_EVENT_KEY)) {
    console.log("[Segment] Sending Event", {
      event,
      data,
    });
  }

  window.analytics?.track?.(event, data);
};

export const sendEventAsync = (
  event: Events,
  data?: SegmentEventData,
): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (shouldDebugWithKey(SEGMENT_DEBUG_EVENT_KEY)) {
      console.log("[Segment] Sending Event", {
        event,
        data,
      });
    }

    if (!window.analytics?.track) {
      reject(new Error("Analytics not available"));
      return;
    }
    window.analytics.track(event, data, () => {
      resolve();
    });
  });
};
